import React from 'react';
import Image from 'next/image';
import styles from './index.module.less';
import { commonImgPath } from '@/shared/app-common';
import { useTranslation } from 'next-i18next';
import NextImage from 'next/image';
import { EventNameSource } from '@/shared/event-types';
import { useAddAccountModal } from '@/context/AddAccountModalProvider';
export default function TopView() {
  const { t } = useTranslation();
  const { openAddAccountModal } = useAddAccountModal();

  return (
    <div className={styles.container}>
      <h1
        style={{ display: 'none' }}
        dangerouslySetInnerHTML={{ __html: t('<b>Protect Your Cam Model Content</b> from Leaks & Theft') }}
      ></h1>
      <div className={styles.desktopView}>
        <div className={styles.content}>
          <div className={styles.badge}>
            <NextImage
              src="/images/common/trusted_by.png"
              alt="erasa"
              width={45}
              height={18}
              fetchPriority="high"
              priority
            ></NextImage>
            <span dangerouslySetInnerHTML={{ __html: t('<p>Trusted by <b>10,000+</b> creators worldwide</p>') }}></span>
          </div>
          <div className={styles.title}>
            <p dangerouslySetInnerHTML={{ __html: t('<b>Protect Your Cam Model Content</b> from Leaks & Theft') }}></p>
          </div>
          <p className={styles.description}>
            {t(
              "Your cam shows are your business. Let's keep them safe. Get real content protection, fast DMCA takedowns, and tools to detect stolen content before it spreads.",
            )}
          </p>
          <button
            type="button"
            className={styles.cta}
            onClick={() => openAddAccountModal(EventNameSource.camModelProtection)}
          >
            {t('Start Free Scan & Protection')}
          </button>
        </div>
        <div className={styles.illustration}>
          <Image
            src={`${commonImgPath}/cam-model-top-icon_compressed.webp`}
            alt="Impersonation Removal Illustration"
            width={400}
            height={250}
            layout="responsive"
            priority
            fetchPriority="high"
          />
        </div>
      </div>

      <div className={styles.mobileView}>
        <div className={styles.badge}>
          <NextImage
            src="/images/common/trusted_by.png"
            alt="erasa"
            width={45}
            height={18}
            fetchPriority="high"
            priority
          ></NextImage>
          <span dangerouslySetInnerHTML={{ __html: t('<p>Trusted by <b>10,000+</b> creators worldwide</p>') }}></span>
        </div>
        <div className={styles.mobileTitle}>
          <p dangerouslySetInnerHTML={{ __html: t('<b>Protect Your Cam Model Content</b> from Leaks & Theft') }}></p>
        </div>
        <p className={styles.mobileDescription}>
          {t(
            `Your cam shows are your business. Let's keep them safe. Get real content protection, fast DMCA takedowns, and tools to detect stolen content before it spreads.`,
          )}
        </p>
        <div className={styles.mobileIllustration}>
          <Image
            src={`https://res-front.pumpsoul.com/prod-erasa/image/cam-model-top-icon_compressed.webp`}
            alt="Impersonation Removal Illustration"
            width={300}
            height={200}
            layout="responsive"
            priority
            fetchPriority="high"
          />
        </div>

        <button
          type="button"
          className={styles.cta}
          onClick={() => openAddAccountModal(EventNameSource.camModelProtection)}
        >
          {t('Start Free Scan & Protection')}
        </button>
      </div>
      <div className={styles.freeContentScan}>{t('No credit card required • Free content scan')}</div>
      <div className={styles.infoSection}>
        <div className={styles.infoContent}>
          <span className={styles.name}>{t('Join Erasa.')}</span>
          <span className={styles.nameDesc}>{t('Protect Your Cam Model Brand!')}</span>
        </div>
      </div>
    </div>
  );
}
